import axios from '@/utilities/axios-global'

export function GET_CODING_SCHEDULE_REQUEST(context, id) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + '/requests/coding/' + id).then(response => {
      context.commit('SET_CODING_SCHEDULE_REQUEST', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function PUT_CODING_SCHEDULE_REQUEST(context, payload) {
  return new Promise((resolve, reject) => {
    axios.put(context.rootState.user.baseApiUrl + '/requests/coding/' + payload.requestId, payload).then(() => {
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_REQUESTS(context, year) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + '/requests?year=' + year).then(response => {
      context.commit('SET_CODING_SCHEDULE_REQUESTS', response.data.codingScheduleRequests)
      context.commit('SET_REVIEW_REQUESTS', response.data.reviewRequests)
      context.commit('SET_INTERIM_REQUESTS', response.data.interimRequests)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_ALL_REQUESTS(context, year) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + '/requests/allrequests?year=' + year).then(response => {
      context.commit('SET_ALL_REQUESTS', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function CHECK_EXISTS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/requests/coding/exists?requestStartDate=${payload.requestStartDate}&codingType=${payload.codingType}`)
      .then(response => {
        resolve()
      }, error => {
        console.log(error)
        reject(error)
      })
  })
}

export function POST_CODING_SCHEDULE_REQUEST(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/requests`, payload).then(response => {
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function POST_ACUTE_CODERS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/requests/acute-coding/${payload[0].requestId}/coders`, payload).then(response => {
      context.commit('CONCAT_ACUTE_CODERS', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function PUT_ACUTE_CODERS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.put(context.rootState.user.baseApiUrl + `/requests/acute-coding/${payload[0].requestId}/coders`, payload).then((response) => {
      context.commit('UPDATE_ACUTE_CODERS', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function DELETE_ACUTE_CODERS(context, payload) {
  return new Promise((resolve, reject) => {
    // axios.delete doesn't normally take a payload, but since this is an array we're using { data: payload }
    axios.delete(context.rootState.user.baseApiUrl + `/requests/acute-coding/${payload[0].requestId}/coders`, { data: payload }).then(() => {
      context.commit('DELETE_ACUTE_CODERS', payload)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function POST_PRO_CODERS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/requests/pro-coding/${payload.requestId}/coders`, payload).then(response => {
      context.commit('CONCAT_PRO_CODERS', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function PUT_PRO_CODERS(context, payload) {
  return new Promise((resolve, reject) => {
    axios.put(context.rootState.user.baseApiUrl + `/requests/pro-coding/${payload.requestId}/coders`, payload).then((response) => {
      context.commit('UPDATE_PRO_CODERS', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function DELETE_PRO_CODERS(context, payload) {
  return new Promise((resolve, reject) => {
    // axios.delete doesn't normally take a payload, but since this is an array we're using { data: payload }
    axios.delete(context.rootState.user.baseApiUrl + `/requests/pro-coding/${payload.requestId}/coders`, { data: payload }).then(() => {
      context.commit('DELETE_PRO_CODERS', payload)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_SPECIALTIES(context, payload) {
  return new Promise((resolve, reject) => {
    if (context.state.specialties.length > 0) {
      resolve()
      return
    }
    axios.get(context.rootState.user.baseApiUrl + `/requests/specialties`).then((response) => {
      context.commit('SET_SPECIALTIES', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_AMBULATORY_SPECIALTIES_LOOKUP(context) {
  return new Promise((resolve, reject) => {
    if (context.state.ambulatorySpecialtiesLookup.length > 0) {
      resolve()
      return
    }
    axios.get(context.rootState.user.baseApiUrl + `/reviewrequests/ambulatory-specialties`).then((response) => {
      context.commit('SET_AMBULATORY_SPECIALTIES_LOOKUP', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GET_SCHEDULE_PERIODS(context) {
  return new Promise((resolve, reject) => {
    axios.get(context.rootState.user.baseApiUrl + `/requests/coding/scheduleperiods`)
      .then(response => {
        context.commit('SET_SCHEDULE_PERIODS', response.data)
        resolve(response)
      }, error => {
        console.log(error)
        reject(error)
      })
  })
}

export default {
  GET_REQUESTS,
  GET_CODING_SCHEDULE_REQUEST,
  PUT_CODING_SCHEDULE_REQUEST,
  POST_CODING_SCHEDULE_REQUEST,
  POST_ACUTE_CODERS,
  DELETE_ACUTE_CODERS,
  PUT_ACUTE_CODERS,
  POST_PRO_CODERS,
  DELETE_PRO_CODERS,
  PUT_PRO_CODERS,
  GET_SPECIALTIES,
  GET_AMBULATORY_SPECIALTIES_LOOKUP,
  CHECK_EXISTS,
  GET_SCHEDULE_PERIODS,
  GET_ALL_REQUESTS
}
